import React, { useEffect, createElement } from 'react';
import { LandingPage } from './pages/LandingPage';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  useEffect(() => {
    // Inject Meta Pixel
    const pixelId = '2782582688765590';
    // @ts-ignore
    !function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ?
        // @ts-ignore
        n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      // @ts-ignore
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      // @ts-ignore
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      // @ts-ignore
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      // @ts-ignore
      if (s && s.parentNode) {
        // @ts-ignore
        s.parentNode.insertBefore(t, s);
      } else {
        // Fallback: no existing <script> tag available (e.g. sandboxed iframe)
        ;
        (b.head || b.documentElement).appendChild(t);
      }
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    // @ts-ignore
    window.fbq('init', pixelId);
    // @ts-ignore
    window.fbq('track', 'PageView');
    // Add noscript fallback
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = `https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`;
    noscript.appendChild(img);
    document.head.appendChild(noscript);
    return () => {
      // Cleanup if needed, though usually pixel stays
      if (document.head.contains(noscript)) {
        document.head.removeChild(noscript);
      }
    };
  }, []);
  return <div className="antialiased" data-id="element-0">
      <LandingPage data-id="element-1" />
      <SocialProofPopup data-id="element-2" />
    </div>;
}